import React from 'react';
import { useNavigate } from 'react-router-dom';

const OrderCard = ({ orderId, items, status, orderDate, deliveredDate, returnedDate }) => {
  const navigate = useNavigate();

  const getStatusStyles = () => {
    switch (status.toLowerCase()) {
      case 'placed':
        return 'text-red-500 bg-red-500 bg-opacity-10';
      case 'shipped':
        return 'text-indigo-400 bg-sky-100';
      case 'delivered':
        return 'text-green-500 bg-green-500 bg-opacity-10';
      case 'returned':
        return 'text-orange-500 bg-orange-500 bg-opacity-10';
      default:
        return 'text-red-500 bg-red-500 bg-opacity-10';
    }
  };

  const getSecondaryInfo = () => {
    if (status.toLowerCase() === 'delivered' && deliveredDate) {
      return `Delivered: ${deliveredDate}`;
    }
    if (status.toLowerCase() === 'returned' && returnedDate) {
      return `Returned: ${returnedDate}`;
    }
    return `Quantity : ${items[0]?.quantity || 1}`;
  };

  
  const handleCardClick = () => {
    try {
      const cleanOrderId = orderId.replace('#', '');
      navigate(`/profile/orders/${cleanOrderId}`);
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  return (
    <article
      className="flex flex-col items-start py-4 w-full bg-white rounded-2xl border border-solid border-slate-300 max-md:max-w-full cursor-pointer hover:shadow-lg transition-shadow duration-200"
      onClick={handleCardClick}
    >
      {/* Order ID */}
      <h3 className="ml-3.5 text-sm font-medium text-sky-950 max-md:ml-2.5">
        {orderId}
      </h3>

      <hr className="shrink-0 self-stretch mt-4 h-px border border-solid border-neutral-200 max-md:max-w-full" />

      {/* Item List */}
      <div className="mt-2.5 mr-5 ml-3.5 max-md:mr-2.5 max-md:max-w-full">
        {items.map((item, index) => (
          <div
            key={index}
            className={`flex gap-3 ${index > 0 ? 'mt-3.5' : ''} max-w-full rounded-md`}
          >
            <img
              src={item.image}
              alt={item.name}
              className="object-contain shrink-0 my-auto rounded-md aspect-square w-[46px]"
            />
            <div className="flex flex-col grow shrink-0 basis-0 w-fit">
              <h4 className="text-base font-medium text-sky-950">{item.name}</h4>
              <p className="self-start mt-1 text-sm text-black opacity-70">
                {index === 0 ? getSecondaryInfo() : `Quantity : ${item.quantity}`}
              </p>
            </div>
          </div>
        ))}
      </div>

      <hr className="shrink-0 self-stretch mt-2.5 h-px border border-solid border-neutral-200 max-md:max-w-full" />

      {/* Status and Date */}
      <div className="flex flex-wrap gap-10 justify-between items-center mt-2.5 mr-5 ml-3.5 w-full max-md:mr-2.5 max-md:max-w-full">
        <div
          className={`flex gap-2.5 justify-center items-center px-2.5 py-1.5 text-sm font-semibold whitespace-nowrap rounded-lg min-h-[30px] ${getStatusStyles()}`}
        >
          <span className="self-stretch my-auto">{status}</span>
        </div>
        <time className="pr-5 text-base font-medium text-black opacity-60 ml-auto">
          {orderDate}
        </time>
      </div>

      <div className="mt-3 ml-3.5 mr-5 w-full text-lg text-semibold text-gray-600 flex items-center gap-8 max-md:mr-2.5">
        <span>Need help with this order?</span>
        <a
          href="tel:+917829928490"
          className="text-blue-600 hover:underline font-medium"
          onClick={(e) => e.stopPropagation()}
        >
          +91-7829928490
        </a>
      </div>

    </article>
  );
};

export default OrderCard;
